import { render } from "./PageDadosMilitar.vue?vue&type=template&id=e080c658"
import script from "./PageDadosMilitar.vue?vue&type=script&lang=js"
export * from "./PageDadosMilitar.vue?vue&type=script&lang=js"

import "./PageDadosMilitar.vue?vue&type=style&index=0&id=e080c658&lang=css"
/* custom blocks */
import block0 from "./PageDadosMilitar.vue?vue&type=custom&index=0&blockType=head"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__